export const dispatchType = {
  default: {
    border: 'border border-default',
    background: 'bg-light hover:bg-dark',
    text: 'text-muted',
  },
  primary: {
    border: 'border border-brand-primary-base',
    background: 'bg-brand-primary-base hover:bg-brand-primary-hover',
    text: 'text-primitive-white',
  },
  secondary: {
    border: 'border border-brand-secondary-base',
    background: 'bg-brand-secondary-base hover:bg-brand-secondary-hover',
    text: 'text-primitive-white',
  },
  disabled: {
    border: 'border border-default disabled:opacity-100',
    background: 'bg-disabled',
    text: 'text-disabled',
  },
};

export const dispatchRadius = {
  default: 'rounded',
  rounded: 'rounded-full',
};

export const dispatchSize = {
  sm: 'h-[32px] w-[32px]',
  default: 'h-[40px] w-[40px]',
  lg: 'h-[48px] w-[48px]',
};
